/**
 * The Moov tenants. This is a multi-tenant codebase — Cleve, KM, AA and Summit run the
 * same screens — so anything that only exists for Moov (the B2B sales portal, vendor/brand
 * logins) asks here rather than spelling the client name out at each call site.
 */
export function isMoovClient(config: { env?: { client?: string } } | null | undefined): boolean {
	const client = config?.env?.client;
	return client === 'moov' || client === 'moov_sandbox';
}

/** Show brand allow-list on salesperson / user forms (Moov B2B portal or ERP rep restriction). */
export function showSalespersonBrandScope(config: { env?: { client?: string }; restrictRepBrands?: boolean } | null | undefined): boolean {
	if (!config) {
		return false;
	}
	if (isMoovClient(config)) {
		return true;
	}
	return !!config.restrictRepBrands;
}

export function filterProductBrandsForSalesperson(
	rows: { manufacturer_id?: unknown; name?: unknown }[]
): { manufacturer_id: number; name: string }[] {
	const feePattern = /^(NOSALESFEE|SALESFEE|Sales\s*Fee|No\s*Sales\s*Fee|Metrc\s*Fee|Brand\s*Payout|Test\b)/i;
	return (Array.isArray(rows) ? rows : [])
		.map((r) => ({
			manufacturer_id: Number(r.manufacturer_id),
			name: String(r.name ?? '').trim() || `Brand #${r.manufacturer_id}`,
		}))
		.filter((b) => Number.isFinite(b.manufacturer_id) && b.manufacturer_id > 0 && !feePattern.test(b.name))
		.sort((a, b) => a.name.localeCompare(b.name));
}
